var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVeryDissatisfied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2291 14.791C21.2301 14.791 22.0416 13.9795 22.0416 12.9785C22.0416 11.9775 21.2301 11.166 20.2291 11.166C19.2281 11.166 18.4166 11.9775 18.4166 12.9785C18.4166 13.9795 19.2281 14.791 20.2291 14.791Z",
    fill: "#D1D6D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7709 14.791C12.7719 14.791 13.5834 13.9795 13.5834 12.9785C13.5834 11.9775 12.7719 11.166 11.7709 11.166C10.7699 11.166 9.95837 11.9775 9.95837 12.9785C9.95837 13.9795 10.7699 14.791 11.7709 14.791Z",
    fill: "#D1D6D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9879 3.91602C9.31788 3.91602 3.91663 9.32935 3.91663 15.9993C3.91663 22.6693 9.31788 28.0827 15.9879 28.0827C22.67 28.0827 28.0833 22.6693 28.0833 15.9993C28.0833 9.32935 22.67 3.91602 15.9879 3.91602ZM16 25.666C10.6591 25.666 6.33329 21.3402 6.33329 15.9993C6.33329 10.6585 10.6591 6.33268 16 6.33268C21.3408 6.33268 25.6666 10.6585 25.6666 15.9993C25.6666 21.3402 21.3408 25.666 16 25.666ZM16 18.416C13.1845 18.416 10.78 20.1681 9.81329 22.6452H11.8312C12.665 21.2073 14.2116 20.2285 16 20.2285C17.7883 20.2285 19.3229 21.2073 20.1687 22.6452H22.1866C21.22 20.1681 18.8154 18.416 16 18.416Z",
    fill: "#D1D6D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeryDissatisfied);
export default __webpack_public_path__ + "static/media/very_dissatisfied.51b8e6982f9ca3e8be3badb7c2870b83.svg";
export { ForwardRef as ReactComponent };